<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Tester</ng-container>
  <ng-container *ngIf="data.id">Edit Tester</ng-container>
</h1>
<mat-dialog-content>

    <aw-tester-form [tester]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-tester-form>

</mat-dialog-content>
